import { ChannelBilibili } from '@/app/components/icons/ChannelBilibili';
import { ChannelDiscord } from '@/app/components/icons/ChannelDiscord';
import { ChannelRed } from '@/app/components/icons/ChannelRed';
import { ChannelTt } from '@/app/components/icons/ChannelTt';
import { ChannelX } from '@/app/components/icons/ChannelX';
import { ChannelYoutube } from '@/app/components/icons/ChannelYoutube';
import { TWITTER_LINK } from '@/app/constants';

export const CN_SOCIAL_LINKS = [
  {
    label: 'Bilibili',
    icon: ChannelBilibili,
    href: 'https://space.bilibili.com/3546707509906117',
  },
  {
    label: 'Xiaohongshu',
    icon: ChannelRed,
    href: 'https://www.xiaohongshu.com/user/profile/66277a1a000000000303295b?xhsshare=CopyLink&appuid=5e5f08880000000001000cf4&apptime=1721633528&share_id=7232bad910cf4b1b8819394c5f886296',
  },
  {
    label: 'Douyin',
    icon: ChannelTt,
    href: 'https://v.douyin.com/iMA3xoFV/',
  },
];

export const EN_SOCIAL_LINKS = [
  {
    label: 'X',
    icon: ChannelX,
    href: TWITTER_LINK,
  },
  {
    label: 'Youtube',
    icon: ChannelYoutube,
    href: 'https://www.youtube.com/channel/UChF9964qVeqdSL9MkzBwCig',
  },
  {
    label: 'Tiktok',
    icon: ChannelTt,
    href: 'https://www.tiktok.com/@vidu_ai?lang=en',
  },
  {
    label: 'Discord',
    icon: ChannelDiscord,
    href: 'https://discord.gg/3pDU8fmQ8Y',
  },
];

export const SUPPORT_HELP_LINK = '/help-center';

export const SUPPORT_TUTORIAL_LINK = 'https://shengshu.feishu.cn/docx/Dtv8dbnUKo5glfxDoLXcEwzSnyd';
